import {
  OPEN_NAVBAR,
  PRODUCT_LIST_DISPLAY,
  SAVE_LAST_SEEN_TAB,
  OPEN_CLASSE_CHOICE
} from '../actions/ui.actions';
import { ProductDisplayList } from '../../types/ui';

export interface UiState {
  navBarOpen: boolean;
  productDisplay: ProductDisplayList;
  myClassTab: 0 | 1 | 2 | 3 | 4 | 5;
  classeChoiceOpen: boolean;
}

const initialState: UiState = {
  navBarOpen: false,
  productDisplay: 'Mosaique',
  myClassTab: 0,
  classeChoiceOpen: false
};

const uiReducer = (state: UiState = initialState, action): UiState => {
  switch (action.type) {
    case OPEN_NAVBAR:
      return {
        ...state,
        navBarOpen: action.payload.navBarOpen
      };
    case PRODUCT_LIST_DISPLAY:
      return {
        ...state,
        productDisplay: action.payload.productDisplay
      };
    case SAVE_LAST_SEEN_TAB:
      return {
        ...state,
        myClassTab: action.payload.myClassTab
      };
    case OPEN_CLASSE_CHOICE:
      return {
        ...state,
        classeChoiceOpen: action.payload.classeChoiceOpen
      };
    default:
      return state;
  }
};
export default uiReducer;
